<app-masterpage>
</app-masterpage>
<div class="page-wrapper">
    <app-header>
    </app-header>

    <div class="container-fluid pt-custom mb-5">
        <div class="modal inmodal" id="detailModal" tabindex="-1" role="dialog" aria-hidden="true">
            <form #attemptForm="ngForm" (ngSubmit)="onSubmit()">
                <div class="modal-dialog modal-xl" style="overflow-y: initial !important;max-width: 1300px;">
                    <div class="modal-content animated flipInY">
                        <div class="modal-header">
                            <h4 class="modal-title">Employee Request Details</h4>
                            <button type="button" class="close" data-dismiss="modal" (click)="closeForm()"><span
                                    aria-hidden="true">&times;</span>
                                <span class="sr-only">Close</span></button>
                        </div>
                        <div class="modal-body modal_box" style="max-height: 80vh;overflow-y: auto;">
                            <div class="row">
                                <button type="button" id="index" name="index" value="0" style="display: none;"></button>
                                <div class="col-md-12">
                                    <table id="example" class="table table-striped table-bordered" style="width:100%">
                                        <thead>
                                            <tr>
                                                <th class="pointer" scope="col">Request date</th>
                                                <th class="pointer" scope="col">Employee name </th>
                                                <th class="pointer" scope="col">Employee type</th>
                                                <th class="pointer" scope="col">Employee position</th>
                                                <th class="pointer" scope="col">Qualification type</th>
                                                <th class="pointer" scope="col">Employee additional qualification</th>
                                                <th class="pointer" scope="col">Employee yearly salary</th>
                                                <th class="pointer" scope="col" style="display: none;">Pending salary increment amount</th>
                                                <th class="pointer" scope="col" style="display: none;">Depreciation amount</th>
                                                <th class="pointer" scope="col">Remark</th>
                                                <th class="pointer" scope="col" style="width: 9%;">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let r of EmployeeDetaillist ;let j = index">
                                                <td>
                                                    <p>{{r.RequestDate}}</p>
                                                </td>
                                                <td>
                                                    <p>{{r.EmpName}}</p>
                                                </td>
                                                <td>
                                                    <p>{{r.EmpType}}</p>
                                                </td>
                                                <td>
                                                    <p>{{r.EmpPosition}}</p>
                                                </td>
                                                <td>
                                                    <p>{{r.QualificationType}}</p>
                                                </td>
                                                <td>
                                                    <p>{{r.EmpAdditionalQualification}}</p>
                                                </td>
                                                <td>
                                                    <p>{{r.EmpSalary}}</p>
                                                </td>
                                                <td style="display: none;">
                                                    <p>{{r.PendingSalaryIncrementAmount}}</p>
                                                </td>
                                                <td style="display: none;">
                                                    <p>{{r.DepreciationAmount}}</p>
                                                </td>
                                                <td>
                                                    <textarea class="form-control" id="Remark{{j}}" name="Remark{{j}}"
                                                        rows="2" maxlength="300"></textarea>
                                                </td>
                                                <td>
                                                    <input type="radio" name="Status{{j}}" value="Accept"
                                                        id="Accept{{j}}"> Accept<br>
                                                    <input type="radio" name="Status{{j}}" value="Reject"
                                                        id="Reject{{j}}"> Reject<br>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div>
                                <button class="btn btn-success" type="submit" style="margin: 5px;">Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <div class="header">
                    <h4 class="title">Employee Detail Pending Requests</h4>
                </div>
                <div class="row justify-content-center card">
                    <div class="col-lg-12 col-md-12 col-12 p-4">
                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-12">
                                <div class="table-responsive subject">
                                    <div class="col-lg-12 col-md-12 col-12">
                                        <div class="row">
                                            <div class="col-md-11">
                                                <div class="py-3">
                                                    <input type="text" id="searchtext"
                                                        class="form-control bg-white border-0 small"
                                                        placeholder="Search for..." [(ngModel)]="searchtext"
                                                        aria-label="Search" aria-describedby="basic-addon2"
                                                        />
                                                </div>
                                            </div>
                                            <div class="col-md-1">
                                                <div class="py-3">
                                                    <button class="btn btn-success" (click)="getEmployeeDetailList();"
                                                        style="margin: 5px;">Search</button>
                                                </div>
                                            </div>
                                        </div>
                                        <table id="example" class="table table-striped table-bordered"
                                            style="width:100%">
                                            <thead>
                                                <tr>
                                                    <th class="pointer" scope="col" (click)="sortBy('SrNo')">Sr. No.
                                                    </th>
                                                    <th class="pointer" scope="col" (click)="sortBy('School')">
                                                        College</th>
                                                        <th class="pointer" scope="col" (click)="sortBy('CollegeCode')">
                                                            College Code</th>
                                                    <th class="pointer" scope="col">View</th>
                                                </tr>
                                            </thead>
                                            <tbody *ngIf="EmployeeMainlist != undefined && EmployeeMainlist.length != 0">
                                                <tr
                                                    *ngFor="let r of EmployeeMainlist |  paginate: { itemsPerPage: pageLimit, currentPage: p };let i = index">
                                                    <td>{{i+1}}</td>
                                                    <td>
                                                        <p>{{r.School}}</p>
                                                    </td>
                                                    <td>
                                                        <p>{{r.CollegeCode}}</p>
                                                    </td>
                                                    <td>
                                                        <button type="button" class="btn btn-success rmb_10"
                                                        (click)="View(i)">View Request</button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tbody *ngIf="EmployeeMainlist == undefined || EmployeeMainlist.length == 0">
                                                <tr>
                                                    <td colspan="4" style="text-align: center;"> No Record Found </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div *ngIf="EmployeeMainlist != undefined && EmployeeMainlist.length != 0" class="card-footer pb-0 pt-3" align="right">
                                            <pagination-controls (pageChange)="p = $event"></pagination-controls>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-login custom-footer">
            <p class="mb-0">Copyright © Netsol IT Solution Pvt. Ltd. 2020 All Rights Reserved</p>
            <img src="assets/images/powered-by.png" alt="netsol-powerd by" class="img-fluid">
        </div>
        <ngx-spinner bdcolor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
            <p style="color: white;">Please Wait.</p>
        </ngx-spinner>
    </div>
</div>